<script lang="ts">
    import { faAngleLeft, faFileExport } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte/internal'
    import { Audience } from '../../../modules/eventsApi/audiences/audience'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import { GridClass, GridCol, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    dayjs.locale('pt-br')

    const dispatch = createEventDispatcher()

    export let audienceId: string = null
    let entity: Audience = new Audience()
    entity.persons = []
    let show = false
    let loaded = false

    async function loadAudience(audienceId) {
        try {
            show = true
            entity = await window.api.events.audiences.getOne(audienceId, { persons: true })
            if (!entity.persons) entity.persons = []
            loaded = true
            loadGrid()
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    onMount(async () => {
        await loadAudience(audienceId)
    })

    function goBack() {
        dispatch('close')
    }

    function formatBorn(born) {
        return !!born ? dayjs(born).locale('pt-br').format('DD/MM/YYYY') : ''
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        grid = new GridClass()
        grid.title = entity.title
        // lista vazia com regras que mostram pessoas quase sempre é uma exclusão tirando todo mundo
        // (mesmo evento, janelas sobrepostas) — o total de cada regra conta antes das exclusões
        grid.subtitle = entity.persons.length
            ? entity.persons.length + (entity.persons.length === 1 ? ' pessoa' : ' pessoas')
            : 'Ninguém neste público agora. Se as regras mostram pessoas, uma regra "Excluir deste público" pode estar tirando todas.'
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Telefone', size: 2 }))
        grid.cols.push(new GridCol({ content: 'E-Mail' }))
        grid.cols.push(new GridCol({ content: 'Nascimento', size: 1 }))
        grid.cols.push(new GridCol({ content: 'Cadastro', size: 1 }))
        for (const p of entity.persons) {
            const line = new GridLine()
            line.slots.push({ content: p.person.name })
            line.slots.push({ content: p.person.phone || '-' })
            line.slots.push({ content: p.person.email || '-' })
            line.slots.push({ content: formatBorn(p.person.born) || '-' })
            line.slots.push({ content: dayjs(p.person.createdAt).format('DD/MM/YYYY') })
            grid.lines.push(line)
        }
    }

    function download(filename, text) {
        var pom = document.createElement('a')
        pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
        pom.setAttribute('download', filename)

        if (document.createEvent) {
            var event = document.createEvent('MouseEvents')
            event.initEvent('click', true, true)
            pom.dispatchEvent(event)
        } else {
            pom.click()
        }
    }
    function exportPersons() {
        let csv = 'Nome,Telefone,E-Mail,Nascimento,Cadastro\n'

        for (const p of entity.persons) {
            csv +=
                (p.person.name || '').replaceAll(',', ' ').replaceAll('"', ' ') +
                ',' +
                (p.person.phone || '') +
                ',' +
                (p.person.email || '') +
                ',' +
                formatBorn(p.person.born) +
                ',' +
                dayjs(p.person.createdAt).format('DD/MM/YYYY') +
                '\n'
        }
        download(entity.title + '.csv', csv)
    }
</script>

<Content footer={true}>
    <Zact>
        <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={goBack} />
        <div class="spacer" />
        <Zbutton color="secondary" icon={faFileExport} label="Exportar" disabled={!entity.persons.length} on:click={exportPersons} />
    </Zact>
    {#if loaded}
        <Zgrid class="h-space" {grid} />
    {/if}
    <LoadSpinner {show} />
</Content>
